<template>
    <div class="modal-header">
        <h4 class="modal-title">
            Tabla de amortización de pagos
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="card-body">
            <div class="table-container">
                <table class="table table-hover amortization-table text-nowrap">
                    <thead>
                        <tr>
                            <th></th>
                            <th colspan="2">FECHA</th>
                            <th></th>
                            <th>SALDO INICIAL</th>
                            <th colspan="6" class="text-center">GENERADO</th>
                            <th colspan="7" class="text-center">A PAGAR c/IVA</th>
                            <th>SALDO FINAL</th>
                            <th colspan="11" class="text-center">Informativo: Detalle del Pago Restante</th>
                        </tr>
                        <tr>
                            <th># Pago</th>
                            <th>Vencimiento</th>
                            <th>Pagado</th>
                            <th>Hora de Pago</th>
                            <th>Capital</th>
                            <th>Interés</th>
                            <th>IVA</th>
                            <th>Comisiones</th>
                            <th>IVA</th>
                            <th>Mora</th>
                            <th>IVA</th>
                            <th>Capital</th>
                            <th>Interés</th>
                            <th>Comisiones</th>
                            <th>Mora</th>
                            <th>Pago Realizado</th>
                            <th>Pago Restante</th>
                            <th>Pago Total</th>
                            <th>Saldo Insoluto</th>
                            <th>Capital</th>
                            <th>Interés</th>
                            <th>Intereses sin IVA</th>
                            <th>IVA</th>
                            <th>Mora</th>
                            <th>Mora Sin IVA</th>
                            <th>IVA</th>
                            <th>Comisiones</th>
                            <th>Comisiones Sin IVA</th>
                            <th>IVA</th>
                            <th>Pago Restante</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="amortizationData.loanAmortization.length > 0">
                            <tr v-for="(amortization, index) in amortizationData.loanAmortization"
                                :class="{ 'row-disabled': !canSelectRow(index) }"
                                :key="amortization.id" @click="selectAmortizationPayment(amortization, index)">
                                <!--1 # Pago-->
                                <td>
                                    {{ amortization.installmentNumber }}
                                </td>
                                <!--2 Vencimiento-->
                                <td>
                                    {{ filters.formatDateView(amortization.dueDate) }}
                                </td>
                                <!--3 Pagado-->
                                <td>
                                    <template v-if="amortization.amortizationPayment.length > 0">
                                        <template
                                            v-if="(amortization.amortizationPayment.length > 0 && amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length > 0) && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                            {{ filters.formatDateSNTimeView(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentDate) }}
                                        </template>
                                        <template v-if="pesosFormat(pagoRestanteApagar(amortization)) === pesosFormat(0)">
                                            {{
                                                /**Nota: Siempre debemos obtener el ultimo registro del array para mostrar en la fila */
                                                filters.formatDateSNTimeView(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentDate)
                                            }}
                                        </template>
                                    </template>
                                </td>
                                <!--4 Hora de Pago-->
                                <td>
                                    <template v-if="amortization.amortizationPayment.length > 0">
                                        <template
                                            v-if="(amortization.amortizationPayment.length > 0 && amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length > 0) && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                            {{ amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentTime }}
                                        </template>
                                        <template v-if="pesosFormat(pagoRestanteApagar(amortization)) === pesosFormat(0)">
                                            {{
                                                /**Nota: Siempre debemos obtener el ultimo registro del array para mostrar en la fila */
                                                amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentTime
                                            }}
                                        </template>
                                    </template>
                                </td>
                                <!--5 Capital-->
                                <td>
                                    <template
                                        v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                        {{ pesosFormat(0) }}
                                    </template>
                                    <template v-else>
                                        {{ pesosFormat(amortization.initialCapital) }}
                                    </template>
                                </td>
                                <!--6 Interés-->
                                <td>
                                    <template v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                        <template
                                            v-if="amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                            {{ pesosFormat(0) }}
                                        </template>
                                        <template v-else>
                                            {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].interestA) }}
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length > 0">
                                            {{ pesosFormat(amortization.amortizationPayment.filter(p => p.paymentTypeId === 3)[amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length -1].interestA) }}
                                        </template>
                                        <template v-else>
                                            {{ pesosFormat(amortization.interest) }}
                                        </template>
                                    </template>
                                </td>
                                <!--7 IVA-->
                                <td>
                                    <template v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                        <template
                                            v-if="amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                            {{ pesosFormat(0) }}
                                        </template>
                                        <template v-else>
                                            {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].taxA) }}
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length > 0">
                                            {{ pesosFormat(amortization.amortizationPayment.filter(p => p.paymentTypeId === 3)[amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length -1].taxA) }}
                                        </template>
                                        <template v-else>
                                            {{ pesosFormat(amortization.tax) }}
                                        </template>
                                    </template>
                                </td>
                                <!--8 Comisiones-->
                                <td>
                                    <template
                                        v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                        {{ pesosFormat(0) }}
                                    </template>
                                    <template v-else>
                                        {{ pesosFormat(amortization.commissions) }}
                                    </template>
                                </td>
                                <!--9 IVA-->
                                <td>
                                    <template
                                        v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                        {{ pesosFormat(0) }}
                                    </template>
                                    <template v-else>
                                        {{ pesosFormat(amortization.taxes) }}
                                    </template>
                                </td>
                                <!--10 Mora-->
                                <td>
                                    {{ pesosFormat(totalLatePaymentGeneration(amortization)) }}
                                </td>
                                <!--11 IVA-->
                                <td>
                                    {{ pesosFormat(taxGeneratedValueAdded(amortization)) }}
                                </td>
                                <!--A PAGAR c/IVA-->
                                <!--12 Capital-->
                                <td>
                                    <template v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                        <template
                                            v-if="amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                            {{ pesosFormat(0) }}
                                        </template>
                                        <template v-else>
                                            {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].capitalPA) }}
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length > 0">
                                            {{ pesosFormat(amortization.amortizationPayment.filter(p => p.paymentTypeId === 3)[amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length -1].capitalPA) }}
                                        </template>
                                        <template v-else>
                                            {{ pesosFormat(amortization.capital) }}
                                        </template>
                                    </template>
                                </td>
                                <!--13 Interés-->
                                <td>
                                    <template
                                        v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                        <template v-if="amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0">
                                            {{ pesosFormat(0) }}
                                        </template>
                                        <template v-else>
                                            {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].interestPA) }}
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length > 0">
                                            {{ pesosFormat(amortization.amortizationPayment.filter(p => p.paymentTypeId === 3)[amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length -1].interestPA) }}
                                        </template>
                                        <template v-else>
                                            {{ pesosFormat(interesApagar(amortization)) }}
                                        </template>
                                    </template>
                                </td>
                                <!--14 Comisiones-->
                                <td>
                                    <template v-if="amortization.amortizationPayment.length > 0">
                                        {{ 
                                            /**Nota: Siempre debemos obtener el ultimo registro del array para mostrar en la fila */
                                            pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].commissionsToPay)
                                        }}
                                    </template>
                                    <template v-else>
                                        {{ pesosFormat(amortization.taxes + amortization.commissions) }}
                                    </template>
                                </td>
                                <!--15 Mora-->
                                <td>
                                    {{ pesosFormat(totalLatePaymentApagar(amortization))}}
                                </td>
                                <!--16 Pago Realizado-->
                                <td>
                                    <template v-if="amortization.amortizationPayment.length > 0">
                                        {{
                                            //Nota: Siempre debemos obtener el ultimo registro del array para mostrar en la fila.
                                            pesosFormat(totalPaymentRemaining(amortization))
                                        }}
                                    </template>
                                </td>
                                <!--17 Pago Restante-->
                                <td>
                                    <!-- <template
                                        v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                        {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining) }}
                                    </template> -->
                                    <template
                                        v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length > 0">
                                        {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length- 1].paymentRemaining) }}
                                    </template>
                                    <template v-else>
                                        {{ pesosFormat(pagoRestanteApagar(amortization)) }}
                                    </template>
                                </td>
                                <!--18 Pago Total-->
                                <td>
                                    <template
                                        v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length > 0">
                                       {{ pesosFormat(amortization.amortizationPayment.filter(p => p.paymentTypeId === 3)[amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length - 1].fullpaymentA) }}
                                    </template>
                                    <template v-else>
                                        {{ pesosFormat(pagoTotalApagar(amortization)) }}
                                    </template>
                                </td>
                                <!--19 Saldo Insoluto-->
                                <td>
                                    <template
                                        v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                        {{ pesosFormat(0) }}
                                    </template>
                                    <template v-else>
                                        {{ pesosFormat(amortization.finalCapital) }}
                                    </template>
                                </td>
                                <!--INFORMATIVO: DETALLES DEL PAGO RESTANTE-->
                                <!--20 Capital-->
                                <td>
                                    <template
                                        v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length > 0">
                                        <!-- <template v-if="amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining === 0"> -->
                                        <template v-if="amortization.amortizationPayment.filter(p => p.paymentTypeId === 3)[amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length - 1].paymentRemaining === 0">
                                            {{ pesosFormat(0) }}
                                        </template>
                                        <template v-else>
                                            <!-- {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].capitalA) }} -->
                                            {{ pesosFormat(amortization.amortizationPayment.filter(p => p.paymentTypeId === 3)[amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length - 1].capitalA) }}
                                        </template>
                                    </template>
                                    <template v-else>                                   
                                        {{ pesosFormat(capitalDetail(amortization)) }}
                                    </template>
                                </td>
                                <!--21 Interés alias Ordinario-->
                                <td>
                                    {{ pesosFormat(interesDetail(amortization)) }}
                                </td>
                                <!--22 Intereses sin IVA-->
                                <td>
                                    {{ pesosFormat(interesSNIVADetail(amortization)) }}
                                </td>
                                <!--23 IVA-->
                                <td>
                                    {{ pesosFormat(interesIVADetail(amortization)) }}
                                </td>
                                <!--24 Mora-->
                                <td>
                                    {{ pesosFormat(moraDetail(amortization)) }}
                                </td>
                                <!--25 Mora Sin IVA-->
                                <td>
                                    {{ pesosFormat(moraDetailSNIVADetail(amortization)) }}
                                </td>
                                <!--26 IVA-->
                                <td>
                                    {{ pesosFormat(moraIVADetail(amortization)) }}
                                </td>
                                <!--27 Comisiones-->
                                <td>
                                   <!--  {{ pesosFormat(getComissionsDetail(amortization)) }} -->
                                </td>
                                <!--28 Comisiones Sin IVA-->
                                <td>
                                   <!--  {{ pesosFormat(getComissionsSNIvaDetail(amortization)) }} -->
                                </td>
                                <!--29 IVA-->
                                <td>
                                    <!-- {{ pesosFormat(getComissionsIvaDetail(amortization)) }} -->
                                </td>
                                <!--30 Pago Restante-->
                                <td>
                                    <!-- <template
                                        v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentType.id === 3">
                                        {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length - 1].paymentRemaining) }}
                                    </template>
                                    <template v-else>
                                        {{ pesosFormat(pagoRestanteApagar(amortization)) }}
                                    </template> -->
                                    <template
                                        v-if="amortization.amortizationPayment.length > 0 && amortization.amortizationPayment.filter(p => p.paymentTypeId === 3).length > 0">
                                        {{ pesosFormat(amortization.amortizationPayment[amortization.amortizationPayment.length- 1].paymentRemaining) }}
                                    </template>
                                    <template v-else>
                                        {{ pesosFormat(pagoRestanteApagar(amortization)) }}
                                    </template>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="30" style="text-align: center;">
                                {{ $getLocaleMessage('common', 'noDataFound') }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import { useToast } from 'vue-toast-notification';

// Acceder a la instancia de la app
const app = getCurrentInstance();
const filters = app?.appContext.config.globalProperties.$filters;
const $toast = useToast();

// Props y Emits
const props = defineProps({
    amortizationData: {
        type: Object,
        default: () => ({})
    }
})

const emit = defineEmits(["close-modal", "selected-amortization-payment", "back-to-form"])

/**Funciones Auxiliares */
const pesosFormat = (value) => {
    return filters.formatNumber(value);
};

/**
 * Función para formatear la fecha de vencimiento
 * @param value 
 */
const getDateVencido = (value) => {
    let vencimiento = new Date(value.dueDate);
    const dateVencimientoOnly = new Date(
        vencimiento.getFullYear(),
        vencimiento.getMonth(),
        vencimiento.getDate()
    );
    return dateVencimientoOnly;
}

/**
 * Función para formatear la fecha actual
 * @param year 
 * @param month 
 * @param day 
 */
const getDateActul = (year = null, month = null, day = null) => {
    // 2026, 1, 22
    let fechaActual = (year === null && month === null && day === null) ? new Date() : new Date(year, month, day);
    const dateActualOnly = new Date(
        fechaActual.getFullYear(),
        fechaActual.getMonth(),
        fechaActual.getDate()
    );
    return dateActualOnly;
}

/**
 * Función para calcular los días transcurridos
 * @param dateActualOnly 
 * @param dateVencimientoOnly 
 */
const getDiasTranscurridos = (dateActualOnly , dateVencimientoOnly) => {
    // Milisegundos en un día
    const MS_PER_DAY = 1000 * 60 * 60 * 24;
    // Dias transcurridos: Diferencia en días
    let daysElapsed = Math.floor(Math.abs(dateActualOnly - dateVencimientoOnly) / MS_PER_DAY);
    return daysElapsed;
}

/**
 * Función para calcular la tasa diaria sin IVA
 */
const getTasaDiariaSNIva = () => {
    let dailyDelinquencyRate = (props.amortizationData.annualRate * 2) / 360; //0.0008333333333333333
    return dailyDelinquencyRate;
}

/**
 * Función para sacar 
 * @param pagoRestante 
 * @param dailyDelinquencyRate 
 * @param daysElapsed 
 */
const getLatePaymentPartial = (pagoRestante, dailyDelinquencyRate, daysElapsed) => {
    let calculationLatePaymentPartial = pagoRestante * dailyDelinquencyRate * daysElapsed * 1.16;
    return calculationLatePaymentPartial;
}

/**
 * Función para sacar la mora acomulada
 * @param value 
 */
const morasAcomuladas = (value) => {
    return value.amortizationPayment.reduce((total, item) => total + item.latePayment, 0);
}

/**
 * La suma total de la columna de PaymentRemaining de la BD de un registro(QuotationId) especifico.
 * @param value 
 */
const totalPaymentRemainingData = (value) => {
    return value.amortizationPayment.reduce((total, item) => total + item.paymentRemaining, 0);
}

/**
 * La suma total de la columna de LatePayment de la BD de un registro(QuotationId) especifico.
 * @param value 
 */
const totalLatePaymentData = (value) => {
    return value.amortizationPayment.reduce((total, item) => total + item.latePayment, 0);
}

/**
 * Función auxiliar para identificar que capital tomar para el calculo de moras generados e informe detallado
 * @param value 
 */
const auxCapital = (value) => {
    const isFirstPayment = value.amortizationPayment.length === 1;
    const paymentAmountData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount;
    const interesIva = value.amortizationPayment[value.amortizationPayment.length - 1].paymentInterest;
    const latePaymentData = value.amortizationPayment[value.amortizationPayment.length - 1].latePayment;
    const remanenteData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentRemaining;
    const mora = 0;
    const moraA = 0;
    let capitalResult = 0;

    if(isFirstPayment) {
        capitalResult = paymentAmountData <= interesIva ? value.capital : (interesIva + value.capital - paymentAmountData);
        return capitalResult;
    }

    capitalResult = (paymentAmountData - latePaymentData - interesIva) > remanenteData ? 0 : (interesIva + mora + remanenteData + interesIva + latePaymentData - paymentAmountData - moraA);
    return capitalResult;
}

/**Datos Calculados */
/**
 * <!--16 Pago Realizado-->
 * Pago total restante
 * Suma de todos los pagos que se guardaron para cubrir pago total
 * La suma total de la columna de PaymentAmount de la BD de un registro(QuotationId) especifico.
 * @param value 
 */
const totalPaymentRemaining = (value) => {
    return value.amortizationPayment.reduce((total, item) => total + item.paymentAmount, 0);
}

/**
 * Mora Generado <!--10 Mora-->
 * Generación total de pagos atrasados
 * @param value Amortización (quotation)
 */
const totalLatePaymentGeneration = (value) => {
    let pagoMensual = Math.abs(value.installmentWithVat - totalPaymentRemaining(value));

    if(pagoMensual <= 0){
        // Pago cubierto
        return Math.abs(value.installmentWithVat - totalPaymentRemaining(value));
    } else {
        // Pagos pendientes
        // Fecha actual
        const dateActualOnly = getDateActul();
        // Fecha de vencimiento
        const dateVencimientoOnly = getDateVencido(value);
        // Paso #1 Sacar los dias transcurridos del día de vencimiento
        // Dias transcurridos: Diferencia en días
        let daysElapsed = getDiasTranscurridos(dateActualOnly, dateVencimientoOnly);

        // validar si ya paso muchos dias de pago
        if(dateActualOnly >= dateVencimientoOnly){
            // Generar Mora : Pago pendiente con MORA 
            // Tasa Diaria sin IVA
            let dailyDelinquencyRate = getTasaDiariaSNIva();

            // Revisar si ya hay un pago existen por flujo a paguitos
            if(value.amortizationPayment.length > 0){
                // Flujo de mora con pagos registrados
                // sobre-escribir la fecha transcurrida del utlimo pago a la fecha actual
                let dateLastPaymentData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentDate;
                let [year, month, day] = dateLastPaymentData.split('-').map(Number);
                let dateLastPayment = getDateActul(year, month - 1, day);
               
                // Sacar todos las moras anteriores con su pago mensual
                // Sacar Mora generada del pago acomulado
                let remanenteData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentRemaining; //Este dato se guarda en BD en PaymentRemaining *Notaa verificar si no va la suma total de todos los paymentReaming totalPaymentRemainingData testear
                
                // Validar si tiene un pago (el utlimo pago se hizo en tiempo y forma)
                if(dateLastPayment <= dateVencimientoOnly) {
                    // En este caso tomamos la capital origen anterior
                    // Verificar si es el primer pago (verificar si esta de mas esta validación o es correcta)
                    let isFirstPayment = value.amortizationPayment.length;

                    if(isFirstPayment === 1){
                        var calculationLatePaymente = (auxCapital(value) * dailyDelinquencyRate * daysElapsed) * 1.16;
                        var calculationLatePaymentResult = calculationLatePaymente / 1.16;
                        return calculationLatePaymentResult;
                    }
                }

                // sobre escribir remanenteData
                let interest = value.amortizationPayment[value.amortizationPayment.length - 1].paymentInterest;
                if(totalPaymentRemaining(value) <= interest){
                    remanenteData = value.capital;
                }

                // Si existe un pago anterior que fue realizado despues de la fecha de vencimiento entonces sobre escribe el tiempo transcurrido con respecto a la ultima fecha de pago
                daysElapsed = getDiasTranscurridos(dateActualOnly, dateLastPayment);
                var calculationLatePayment = (remanenteData * dailyDelinquencyRate * daysElapsed) * 1.16;
                // Suma todas las moras acomuladas
                let morasAcomuladasData = morasAcomuladas(value);
                var result = (morasAcomuladasData + calculationLatePayment) / 1.16;
                return result;                
            }

            // Flujo de mora sin pagos registrados
            // Va directo a Capital
            var calculationLatePayment = (value.capital * dailyDelinquencyRate * daysElapsed) * 1.16;
            // Nota: No aplica la suma de moras acomuladas porque no se ha guardado nigun registro de pago lo cual va directo calculationLatePayment
            var result = calculationLatePayment / 1.16;
            return result;
        } else {
            //No Generar Mora porque esta en tiempo y forma de hacer su pago: Un pago pendiente SIN Mora
            return 0;
        }
    }
}

/**
 * IVA Generado
 *  <!--11 IVA-->
 * @param value 
 */
const taxGeneratedValueAdded = (value) =>{
    return totalLatePaymentGeneration(value) * 0.16;
}

/**
 * Ineteres a pagar = ineres generado + iva generado
 * <!--13 Interés-->
 * @param value
 */
const interesApagar = (value) => {
    let quotationInteres = value.interest;
    let quotationIva = value.tax;
    let result = quotationInteres + quotationIva;
    return result;
}

/**
 * <!--15 Mora-->
 * @param value
 */
const totalLatePaymentApagar = (value) => {
    return totalLatePaymentGeneration(value) + taxGeneratedValueAdded(value);
}

/**
 * <!--17 Pago Restante-->
 * @param value
 */
const pagoRestanteApagar = (value) => {
    let capital = value.capital;
    let mensual = Number(value.installmentWithVat); //.toFixed(2);
    let moraApagar = totalLatePaymentApagar(value);
    let totalPagado = totalPaymentRemaining(value);

    // MEJORA (para sistemas financieros)
    const diferencia = Math.abs(totalPagado - mensual);
    if (diferencia < 0.01) {
        // Pago Mensual completado
        return 0;
    }
    
    // if(totalPagado === mensual){
    //     console.log("aqui 1")
    //     // Pago Mensual completado
    //     return Math.abs(mensual - totalPagado);
    // }

    if (moraApagar <= 0) {
        // Pago Mensual sin Cargo

        if(value.amortizationPayment.length > 0){
            const pagoRegistrado = value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount;
            const calRestante = Math.abs(mensual - pagoRegistrado);
            return calRestante;
        }

        return mensual;
    }
    
    // Pago Mensual con Cargo
    let tasaDiariaSNIVA = getTasaDiariaSNIva();
    const dateActualOnly = getDateActul();
    const dateVencimientoOnly = getDateVencido(value);
    let daysElapsed = getDiasTranscurridos(dateActualOnly, dateVencimientoOnly);

    // Flujo con pagos registrados
    if(value.amortizationPayment.length > 0){
        // Suma del ultimo remanente registrado + la ultima mora + la suma total de pago o la suma del monto capturado de pago ultimo
        let ultimoRemanente = value.amortizationPayment[value.amortizationPayment.length - 1].paymentRemaining;
        let tasaDiariaSNIVA = getTasaDiariaSNIva();
        // Sobre escribir la fecha transcurrida del utlimo pago a la fecha actual
        let dateLastPaymentData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentDate;
        const [year, month, day] = dateLastPaymentData.split('-').map(Number);
        let dateLastPayment = getDateActul(year, month - 1, day);
        // Sobre escribir el tiempo transcurrido de acuerdo al ultimo pago registrado ya no de la fecha del vencimiento origen
        daysElapsed = getDiasTranscurridos(dateActualOnly, dateLastPayment);
        
        if(dateLastPayment <= dateVencimientoOnly){
            let result = ultimoRemanente + moraApagar;
            return result;
        }

        
        let pagoAnterior = value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount;
        let moraAnterior = value.amortizationPayment[value.amortizationPayment.length - 1].latePayment;

        if(pagoAnterior >= moraAnterior){
            // La mora anterior fue saldada
            let moraActual = moraDetail(value);
            let calPagoRestante = ultimoRemanente + moraActual;
            return calPagoRestante;
        }

        let generarMora = (ultimoRemanente * tasaDiariaSNIVA * daysElapsed) * 1.16;
        let result = ultimoRemanente + generarMora;
        return result;
    }

    // Flujo sin pagos registrados
    let calPartial = getLatePaymentPartial(capital, tasaDiariaSNIVA, daysElapsed);
    let result = mensual + calPartial - totalPagado;
    return result;
}

/**
 * <!--18 Pago Total-->
 * @param value
 */
const pagoTotalApagar = (value) => {
    let capital = value.capital;
    let mensual = value.installmentWithVat;
    let moraApagar = totalLatePaymentApagar(value);
    let totalPagado = totalPaymentRemaining(value);
    if (moraApagar <= 0) {
        // Pago Mensual sin Cargo
        return mensual;
    }

    // Pago Mensual con Cargo
    let tasaDiariaSNIVA = getTasaDiariaSNIva(); 
    const dateActualOnly = getDateActul();
    const dateVencimientoOnly = getDateVencido(value);
    let daysElapsed = getDiasTranscurridos(dateActualOnly, dateVencimientoOnly);
   
    // Flujo con pagos registrados
    if(value.amortizationPayment.length > 0){
        let pagoRemanente = value.amortizationPayment[value.amortizationPayment.length - 1].paymentRemaining;
        let tasaDiariaSNIVA = getTasaDiariaSNIva();
        let dateLastPaymentData = value.amortizationPayment[value.amortizationPayment.length - 1].paymentDate;
        const [year, month, day] = dateLastPaymentData.split('-').map(Number);
        let dateLastPayment = getDateActul(year, month - 1, day);
        daysElapsed = getDiasTranscurridos(dateActualOnly, dateLastPayment);

        if(dateLastPayment <= dateVencimientoOnly){
            let pagoRestante = pagoRestanteApagar(value);
            let result = totalPagado + pagoRestante;
            return result;
        }

        let pagoAnterior = value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount;
        let moraAnterior = value.amortizationPayment[value.amortizationPayment.length - 1].latePayment;
        let interesAnterior = value.amortizationPayment[value.amortizationPayment.length - 1].paymentInterest;

        let calCapitalOp = pagoRemanente;
        if(pagoAnterior < interesAnterior){
            calCapitalOp = value.capital;
        }

        let generarMoraActual = (calCapitalOp * tasaDiariaSNIVA * daysElapsed) * 1.16;
        let pagoRemanenteMora = pagoRemanente + generarMoraActual;
        let result = totalPagado + pagoRemanenteMora;
        return result;
    }

    // Flujo sin pagos registrados
    let calPartial = getLatePaymentPartial(capital, tasaDiariaSNIVA, daysElapsed);
    let result = mensual + calPartial - totalPagado;
    return result;
}

/**
 * <!--21 Interés alias Ordinario-->
 * @param value
 */
const interesDetail = (value) => {
    const moraAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].latePayment : 0;
    const moraActual = moraDetail(value);
    const ordinarioAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentInterest : 0;
    const ordinarioActual = interesApagar(value);
    const pagoAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount : 0;
    const existePrimerPago = value.amortizationPayment.length > 0 ? true : false;
    let fechaAnteriorBD = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentDate : null;
    let fechaAnterior = null;
    if(fechaAnteriorBD !== null){
        let [year, month, day] = fechaAnteriorBD.split('-').map(Number);
        fechaAnterior = getDateActul(year, month - 1, day);
    }
    const fechaActual = getDateActul();
    const fechaDeVencimiento = getDateVencido(value);
    let saldo = Math.abs(pagoAnterior - moraAnterior);

    // El interes siempre se trata de cubrir desde el primer pago
    if (existePrimerPago) {
        // Validamos si con el pago ingresado este se pudo cubrir en su totalidad o si no se alcanzo cubrir
        // Primero preguntar si anteriormente existio una mora por cubrir antes del pago del interes
        if (moraAnterior > 0) {
            // Si existio una mora por cubrir anteriormente
            // Revisar la mora anterior se termino de saldar
            if(pagoAnterior > moraAnterior){ // <!-- Escenario 25
                // Si el resultado es mayor quiere decir que si cubrio la mora anterior
                // Verificar si el saldo que quedo ayuda a cubrir el interes anterior
                if(saldo > ordinarioAnterior){
                    return 0;
                }
                // Si no es mayor hay que mostrar que alcanzo cubrir del interes anterior
                return Math.abs(saldo - ordinarioAnterior);
            }

            if(ordinarioAnterior === 0){ // <!-- Escenario 9
                return ordinarioAnterior;
            }

            if(saldo > ordinarioActual){ 
                return 0;
            }

            if(moraActual !== 0){ // <--- Escenario 23
                return ordinarioActual;
            }
            
            return Math.abs(saldo - ordinarioActual);
        }

        // No existio nigun mora por cubrir anteriormente
        // Existe algun pago para ver si se cubrio el interes
        if(pagoAnterior > 0){
            if(pagoAnterior > ordinarioAnterior){
                return 0;
            }

            return Math.abs(pagoAnterior - ordinarioAnterior);
        }
    }

    // Si aun no existe algun registro de pago entonces el pago oridinario esta intacto
    return ordinarioActual;
}

/**
 * <!--22 Intereses sin IVA-->
 * @param value
 */
const interesSNIVADetail = (value) => {
    return interesDetail(value) / 1.16;
}

/**
 * <!--23 IVA-->
 * @param value
 */
const interesIVADetail = (value) => {
    return interesSNIVADetail(value) * 0.16;
}

/**
 * Procedimiento para generar la Mora
 * <!--24 Mora-->
 * @param value
 */
const moraDetail = (value) => {
    const pagoAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentAmount : 0;
    const moraAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].latePayment : 0;
    const interesAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentInterest : 0;
    const remanenteAnterior = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentRemaining : 0;
    let fechaAnteriorBD = value.amortizationPayment.length > 0 ? value.amortizationPayment[value.amortizationPayment.length - 1].paymentDate : null;
    let fechaAnterior = null;
    if(fechaAnteriorBD !== null){
        let [year, month, day] = fechaAnteriorBD.split('-').map(Number);
        fechaAnterior = getDateActul(year, month - 1, day);
    }
    const fechaDeVencimiento = getDateVencido(value);
    const fechaActual = getDateActul();
    const existenPagos= value.amortizationPayment.length > 0 ? true : false;
    const capital = value.capital;
    let tasaDiariaSNIVA = getTasaDiariaSNIva();

    if(existenPagos){
        // Existen pagos Anteriores
        // Dame la fecha del ultimo pago anterior
        if(fechaAnterior !== null){
            // Validar si no ocupare llevar esta validación aqui if (fechaActual <= fechaDeVencimiento) si es true entra a lo programado si es false retornaria 0
            // Resulto que estaba en lo correcto si me falta agregar esta validación
            if(fechaActual <= fechaDeVencimiento) { // <!-- Cubre el Escenario 30 Pago Normal (Se trabaja sin verificar el tipo por la razon de que cuando consultamos por primera vez la tabla ahi no contamos con la selección de tipo entonces por eso se opto por una solución generica)
                // No debemos generar Mora
                return 0;
            }

            // Verificar los dias transcurridos de la fecha del pago anterior
            // let diasTranscurridos = getDiasTranscurridos(fechaActual, fechaAnterior);
            let diasTranscurridos = fechaAnterior <= fechaDeVencimiento ? getDiasTranscurridos(fechaActual, fechaDeVencimiento) : getDiasTranscurridos(fechaActual, fechaAnterior);
            // Sacar capital
            let calCR = capital < remanenteAnterior ? capital : remanenteAnterior;
            if(pagoAnterior < moraAnterior){ // <!-- Escenario 23
                // Verificamos si podemos ocupar la formula de la generación de la Mora si resulta que el pago es mayor si no toca mostrar el sobrante pendiente por pagar
                return Math.abs(pagoAnterior - moraAnterior);
            }

            // Generar Mora actual
            // =(+AE20*$S$8*AN20*AQ20)*1.16
            // Calcular mora (Falta anexar la multiplicación por el 100%)
            let resultMora = (calCR * tasaDiariaSNIVA * diasTranscurridos) * 1.16;
            return resultMora;
        }
    }

    // Ocupamos Generar Mora
    if (fechaActual > fechaDeVencimiento) {
        let diasTranscurridosSinPagos = getDiasTranscurridos(fechaActual, fechaDeVencimiento);
        if (diasTranscurridosSinPagos > 0) {
            // Generar Mora actual
            // =(+AE20*$S$8*AN20*AQ20)*1.16
            // Calcular mora (Falta anexar la multiplicación por el 100%)
            let resultMoraSNPagos = (capital * tasaDiariaSNIVA * diasTranscurridosSinPagos) * 1.16;
            return resultMoraSNPagos;
        }
    }   

    // No existe mora a generar
    return 0;
}

/**
 * <!--25 Mora Sin IVA-->
 * @param value
 */
const moraDetailSNIVADetail = (value) => {
    return moraDetail(value) / 1.16;
}

/**
 * <!--26 IVA-->
 * @param value
 */
const moraIVADetail = (value) => {
    return moraDetailSNIVADetail(value) * 0.16;
}

/**
 * <!--20 Capital-->
 * @param value
 */
const capitalDetail = (value) => {
    const existenPagos = value.amortizationPayment.length > 0 ? true : false;

    if (existenPagos) {
        let calCapital = 0;

        if (pagoRestanteApagar(value) === 0) {
           // Capital queda en 0 tambien (Capital Pagado) Capital = 0
            return calCapital;
        }

        // Saca (Saldo capital)  Capital = PagoRestante - Interes - Mora
        calCapital = pagoRestanteApagar(value) - interesDetail(value) - moraDetail(value);
        return calCapital;        
    }

    // Origen (Capital Inicial) Capital = Mensualidad - Intres - Iva
    return value.capital;
}

const selectAmortizationPayment = (data, index) => {
    if (!canSelectRow(index)) {
        $toast.warning('Debe completar el pago anterior antes de continuar.');
        return;
    }

    emit('back-to-form');
    const selectData = [data];
    // console.log("ENVIANDO FILA SELECCIONADA: ", selectData);
    emit('selected-amortization-payment', selectData);
}

// Area de validaciones
const canSelectRow = (index) => {
    // Primera fila siempre disponible
    if (index === 0) return true;
    const previous = props.amortizationData.loanAmortization[index - 1];
    // Si el pago restante de la fila anterior es 0, está pagada
    let previousData =  Number(pagoRestanteApagar(previous).toFixed(2));
    return previousData === 0;
};
</script>

<style scoped>
/* tus estilos originales */
.table-container {
    max-height: 400px;
    overflow-y: auto;
}

.table th {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
}

.summary-card {
    border-left: 4px solid #0d6efd;
}

.highlight-row {
    background-color: #f0f8ff;
}

.modal-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
}

.modal-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 500;
}

.close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
}

/* Contenedor scroll como ya lo tienes */
.table-container {
    max-height: 400px;
    overflow-x: auto;
    overflow-y: auto;
    border: 1px solid #ccc;
}

/* Tabla con bordes completos */
.amortization-table {
    border-collapse: collapse;
    width: 100%;
    font-size: 13px;
}

/* Celdas con borde */
.amortization-table th,
.amortization-table td {
    border: 1px solid #b8b8b8;
    padding: 4px 6px;
    text-align: center;
}

/* Primera fila agrupada (color naranja como Excel) */
.amortization-table thead tr:nth-child(1) th {
    background-color: #d97a00;
    color: white;
    font-weight: bold;
    text-align: center;
    border: 1px solid #9c5c00;
}

/* Segunda fila de encabezados (color azul como Excel) */
.amortization-table thead tr:nth-child(2) th {
    background-color: #1a4f8b;
    color: white;
    font-weight: bold;
    border: 1px solid #0f345a;
}

/* Filas del cuerpo */
.amortization-table tbody tr td {
    background: #fff;
}

/* Hover (no tan fuerte) */
.amortization-table tbody tr:hover {
    background-color: #f2f7ff;
}

/* Encabezados sticky */
.amortization-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
}

.amortization-table tbody tr {
    cursor: pointer;
}

.amortization-table tbody tr:hover td {
    background-color: #f2f7ff;
    transition: background-color 0.15s ease-in-out;
}

.row-disabled {
    /*pointer-events: none;*/
    opacity: 0.5;
    background-color: #f5f5f5;
    cursor: not-allowed;
}
</style>